export default __webpack_public_path__ + "static/media/Elder Wand - Img - Final (2)_04.fdf01c16.jpg";